export default __webpack_public_path__ + "static/media/logo-text.933a806b.png";